<template>
  <div class="wrap">
    <base-table
      :base-url="urlWithFilters"
      ref="baseTable"
      @load-success="onLoadSuccess"
      @load-error="onLoadError"
      @refresh="onRefresh"
      v-loading="isRefreshing"
      element-loading-spinner="el-icon-loading"

    >
      <template v-slot>
        <el-table
          :data="items"
          stripe
          class="w-100"
          max-height="600"
          row-key="id"
          :row-class-name="rowClass"
        >
          <el-table-column
            prop="name"
            label="Date"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="reg_msg_count"
            label="SMS"
            min-width="90"
          ></el-table-column>
          <el-table-column
            prop="unique_bulk_msg_count"
            label="Group SMS"
            min-width="105"
          ></el-table-column>
          <el-table-column
            prop="call_count"
            label="Calls"
            min-width="90"
          ></el-table-column>
          <el-table-column
            prop="call_total_duration"
            label="Calls Duration"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="reg_em_msg_count"
            label="Emails"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="unique_bulk_em_msg_count"
            label="Group Emails"
            min-width="115"
          ></el-table-column>
        </el-table>
      </template>
    </base-table>
  </div>
</template>

<script>
import TableWithoutPagination from '../../components/table-without-pagination';
import {addQueryParams} from '../../libs/url';

export default {
  extends: TableWithoutPagination,
  props: {
    params: Object,
  },

  data() {
    return {
      filters: {},
    };
  },

  computed: {
    /**
     * @return {string}
     */
    urlWithFilters() {
      return addQueryParams(this.url, _.assign({}, this.filters, this.params));
    },
  },

  methods: {
    /**
     * @param {Array} items
     */
    onLoadSuccess({items}) {
      this.items = items;
      this.$emit('success');
    },

    /**
     * @param error
     * @emits validation-error
     */
    onLoadError({response: {status, data}}) {
      if (status === 422) {
        this.$emit('validation-error', data.errors || {});
      }
    },

    rowClass({row}) {
      return _.has(row, 'children') ? 'font-weight-bold' : '';
    },
  }
}
</script>
